export default __webpack_public_path__ + "static/media/pharmacy-en.9bde9edf.svg";